/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';
import { Eyebrow, Icon, size, TextComponent } from '@marriott/mi-ui-library';
import { CardArt } from '../../molecules/CardArt';

import { OffersDetailsCardProps } from './OffersDetailsCard.types';

export const OffersDetailsCardWrapper: FC<OffersDetailsCardProps> = props => {
  const offersData: any = props?.offersData?.responseObject?.offers?.[0];
  const componentId = props?.model?.componentId;
  const isCobrandSingleOffer = props?.offersData?.responseObject?.offers?.[0]?.type === 'Single Card';
  const isPrimaryImageAvailable = !!props?.offersData?.responseObject?.offers?.[0]?.media?.primaryImage?.imageSrc;
  const isHeroImageVariation = isCobrandSingleOffer && isPrimaryImageAvailable;

  return (
    <div className={props?.model?.styleclass ?? ''}>
      <div className="offerDetails-container container">
        <div className="content-wrapper">
          {isHeroImageVariation ? (
            <>
              <TextComponent
                contentAlignment="left"
                header={offersData?.detailsTitle}
                componentId={componentId}
                headerFontSize={size.small}
                styleclass={'p-0 text-title'}
                descriptionText={offersData?.descriptionBody1}
                showLessDesc={false}
                descriptionFontSize={size.small}
              />
              <TextComponent
                contentAlignment="left"
                subHeader={offersData?.detailsSubTitle}
                componentId={componentId}
                subHeaderFontSize={size.medium}
                styleclass={'p-0 text-sub-details '}
                descriptionText={offersData?.descriptionBody2}
                showLessDesc={false}
                descriptionFontSize={size.small}
              />
            </>
          ) : (
            <CardArt offersData={props?.offersData} model={props?.model} />
          )}
        </div>
        <div className="listItem-wrapper">
          <div className="list-container">
            <div className="mb-3">
              <Eyebrow text={offersData?.bulletsTitle} />
            </div>
            {offersData?.needToKnowBullets?.length > 0 &&
              offersData?.needToKnowBullets?.map((bullet: any, idx: number) => {
                return (
                  bullet?.text !== null &&
                  bullet?.text !== undefined &&
                  bullet?.text?.length > 0 && (
                    <div className="bullet-points" key={bullet?.text + idx}>
                      <div className="col p-0 m-icon-text">
                        <Icon iconClass={`${bullet?.icon} icon-s`}></Icon>
                        <span className="t-font-s">{bullet?.text}</span>
                      </div>
                    </div>
                  )
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};
